import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../styles/theme";

import Fab from "@mui/material/Fab";

import { KeyboardArrowUpOutlined, WhatsApp } from "@mui/icons-material";

import { ScrollTop } from "../utils/scrollTop";

export interface Props {
  window?: () => Window;
  children?: React.ReactElement<unknown>;
}

const Main: React.FC<Props> = (props) => {
  const whatsappNumber = "+244941392971";
  const whatsappMessage =
    "Olá, gostaria de saber mais sobre os vossos serviços.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage,
  )}`;

  return (
    <ThemeProvider theme={theme}>
      <Header />

      <div id="back-to-top-anchor" />

      <Outlet />

      <Footer />

      {/* WhatsApp FAB */}
      <Fab
        component="a"
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="chat on whatsapp"
        sx={{
          position: "fixed",
          bottom: 80, // stays ABOVE scroll button
          right: 16,
          backgroundColor: "#25D366",
          color: "#fff",
          zIndex: 9999,
          "&:hover": {
            backgroundColor: "#1ebe5d",
          },
        }}
      >
        <WhatsApp />
      </Fab>

      {/* Scroll To Top FAB */}
      <ScrollTop {...props}>
        <Fab
          color="primary"
          size="small"
          aria-label="scroll back to top"
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
          }}
        >
          <KeyboardArrowUpOutlined />
        </Fab>
      </ScrollTop>
    </ThemeProvider>
  );
};

export default Main;
